import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export default function KPITotalReelsListItem(props){
    return (
        <TableRow>
            <TableCell sx={{fontWeight:props.data.desc==='Total'?'bold':'normal'}}>{props.data.prodName} ({props.data.prodNum})</TableCell>
            <TableCell align="right" sx={{width:"75px", fontWeight:props.data.desc==='Total'?'bold':'normal'}}>{new Intl.NumberFormat('en-US').format(props.data.amount.toFixed(0))}</TableCell>
        </TableRow>
    )
}

